<template>
  <lm-icon-button
    class="Star"
    :icon="resolveIcon"
    svg
    :svg-size="iconSize"
    :highlight="checked"
    :tooltip="checked ? 'Unmark as favorite' : 'Mark as favorite'"
    @click="$emit('click', $event)"
  />
</template>

<script>
import LmIconButton from '@/components/ui/LmIconButton'
export default {
  name: 'StarButton',
  components: {LmIconButton},
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: String,
      default: '24'
    }
  },
  computed: {
    resolveIcon() {
      return this.checked ? 'star' : 'starBorder'
    }
  }
}
</script>
